import React from 'react'
import styles from './SpecialCollaboration.module.css'

export default function SpecialCollaboration() {
    return (
        <section
            id='special-collaboration'
            className={styles.specialCollaboration}
        >
            <h1 className={styles.specialCollaborationPc}>
                <img
                    src={`/pages/business/foodstadium/special-collaboration-pc.svg`}
                    alt='フーズラボ × フードスタジアムの強力コラボ！'
                />
            </h1>
            <h1 className={styles.specialCollaborationSp}>
                <img
                    src={`/pages/business/foodstadium/special-collaboration-sp.png`}
                    alt='フーズラボ × フードスタジアムの強力コラボ！'
                />
            </h1>
            <p className={styles.specialCollaborationText}>
                飲食業界に特化した
                <span className={styles.br}>
                    採用DXプラットフォームで、
                    <br />
                    貴社の採用課題を解決。
                </span>
                <span className={styles.br}>
                    求める人材が、きっと見つかります。
                </span>
            </p>
            <div className={styles.specialCollaborationBox}>
                <div className={styles.boxLeft}>
                    <h2>
                        <span>飲食人材</span>へのアプローチが
                        <br />
                        ここまでできて、<span>コストゼロ</span>
                    </h2>
                    <p className={styles.boxLeftNote}>
                        ※採用決定で初めて費用発生
                    </p>
                    <p className={styles.boxLeftText}>
                        求人、スカウトからエージェントサポートまでの全てのアプローチ機能を、採用決定までコストゼロでご利用いただけます。登録者層は、イタリアン、フレンチ、和食、カフェなどの経験者や、店長・料理長・本社職など豊富な経験を持つ＜正社員＞飲食人材にアプローチできます。
                    </p>
                </div>
                <div className={styles.boxRight}>
                    <img
                        src={`/pages/business/foodstadium/special-collaboration-box-right-image.png`}
                        alt='FoodsLaboの画像'
                    />
                </div>
            </div>
        </section>
    )
}
